var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-row',[_c('b-col',[_vm._v(" API IP address: "+_vm._s(_vm.ip)+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }